import './../../scss/blocks/_contentcards.scss'

document.addEventListener('DOMContentLoaded', () => {
    const moreCardsButton = document.querySelectorAll('.js-contentcards__show-all-button')
    moreCardsButton.forEach(function(button) {
        const cardsContainer = button.closest('.js-contentcards')
        button.addEventListener('click', () => {
            cardsContainer.classList.toggle('contentcards-show-all')
        })
    })
})
